export default __webpack_public_path__ + "static/media/sync_time.207e52f0.svg";